import React from 'react';
import { Box, Container, Link } from '@chakra-ui/react';
import { withPrefix } from 'gatsby';
import { Navigation } from '../Navigation';

function Header() {
  return (
    <Box
      as='header'
      position='sticky'
      top='0'
      zIndex='10'
      bg='navy'
      color='white'
      borderTop={5}
      borderTopStyle='solid'
      borderColor='orange'
      backgroundImage={`url(${withPrefix('/pattern.svg')})`}
      backgroundRepeat='repeat'
      backgroundPosition='left top'
      backgroundSize='80px'
      _after={{
        content: '""',
        position: 'absolute',
        bottom: '0',
        left: '0',
        width: '100%',
        height: '40%',
        background: 'linear-gradient(360deg, #004C97 0%, rgba(0, 76, 151, 0.00) 100%)',
      }}
    >
      <Link
        variant='buttonInverse'
        href='#main'
        className='skip-link'
        position='fixed'
        top={20}
        left={20}
        zIndex='2'
        transform='translateY(-200%)'
        transition='transform 0.2s ease-in-out'
        textTransform='uppercase'
        fontSize='sm'
        _focus={{
          transform: 'translateY(0)',
        }}
      >
        Skip to main content
      </Link>
      <Container maxWidth='container.xl' padding='0' zIndex='1' position='relative'>
        <Navigation />
      </Container>
    </Box>
  );
}

export default Header;
